import React, {PropTypes} from 'react';
import moment from 'moment';
import EntryRosterModalContainer from './EntryRosterModalContainer.jsx';
import Panel from 'shared/Panel.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const EntryDetailSummary = ({
  groupCode,
  pairCode,
  entryNumber,
  teamName,
  tournamentName,
  squadDateTime,
  timeZoneDisplayName,
  readOnly,
  isCancelled,
  onManageRosterClick,
  onViewRosterClick,
  onChangeSquadClick,
  onRemoveSquadClick,
  onChangeEventClick,
  divisionName,
  allowChangeBetweenFreeEvents
}) => (
  <Panel className="panel-primary"
    title="Entry Details">
    <div className="row">
      <div className="col-sm-6">
        <div className="form-group">
          <label>{'Tournament'}</label>
          <div>{tournamentName || '-'}</div>
        </div>
      </div>
      <div className="col-sm-6">
        <div className="form-group">
          <label>{'Team Name'}</label>
          <div>{teamName || '-'}</div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-5">
        <div className="form-group">
          <label>{'Reservation No.'}</label>
          <div>{entryNumber || '-'}</div>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="form-group">
          <label>{'Group Code'}</label>
          <div>{groupCode || '-'}</div>
        </div>
      </div>
      <div className="col-sm-3">
        <div className="form-group">
          <label>{'Companion Code'}</label>
          <div>{pairCode || '-'}</div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-5">
        <div className="form-group">
          <label>{'Squad Date/Time'}</label>
          <div>
            {
              squadDateTime
              ? `${moment.parseZone(squadDateTime).format('MMM Do, YYYY - hh:mm A')}
              (${timeZoneDisplayName})`
              : '-'
            }
          </div>
        </div>
      </div>
      <div className="col-sm-4">
        <div className="form-group">
          <label>{'Cancelled'}</label>
          <div>{isCancelled ? 'Yes' : 'No'}</div>
        </div>
      </div>
      <div className="col-sm-3">
        <div className="form-group">
          <label>{'Division'}</label>
          <div>{divisionName}</div>
        </div>
      </div>
    </div>
    <div className="row">
      <DisplayIf condition={!isCancelled && !readOnly}>
        <button
          type="button"
          className="btn btn-link pull-left"
          onClick={onChangeSquadClick}>
          {squadDateTime ? 'Change Squad' : 'Add Squad'}
        </button>
        <DisplayIf condition={allowChangeBetweenFreeEvents}>
          <button
            type="button"
            className="btn btn-link pull-left"
            onClick={onChangeEventClick}>
            {'Change Event'}
          </button>
        </DisplayIf>
        <DisplayIf condition={!!squadDateTime}>
          <button
            type="button"
            className="btn btn-link pull-left"
            onClick={onRemoveSquadClick}>
            {'Remove Squad'}
          </button>
        </DisplayIf>
      </DisplayIf>
      {
        readOnly
        ? <button
            className="btn btn-link pull-right"
            type="button"
            onClick={onViewRosterClick}>
            {'View Roster'}
          </button>
        : <button
            className="btn btn-link pull-right"
            type="button"
            onClick={onManageRosterClick}>
            {'Manage Roster'}
          </button>
      }
    </div>
    <EntryRosterModalContainer />
  </Panel>
);

EntryDetailSummary.propTypes = {
  groupCode: PropTypes.string,
  pairCode: PropTypes.string,
  entryNumber: PropTypes.string,
  divisionName: PropTypes.string,
  teamName: PropTypes.string,
  tournamentName: PropTypes.string,
  squadDateTime: PropTypes.string,
  timeZoneDisplayName: PropTypes.string,
  readOnly: PropTypes.bool,
  isCancelled: PropTypes.bool,
  onManageRosterClick: PropTypes.func,
  onViewRosterClick: PropTypes.func,
  onChangeSquadClick: PropTypes.func,  
  onRemoveSquadClick: PropTypes.func,
  onChangeEventClick: PropTypes.func,
  allowChangeBetweenFreeEvents: PropTypes.bool
};

EntryDetailSummary.defaultProps = {
  groupCode: '',
  pairCode: '',
  entryNumber: '',
  divisionName: '',
  teamName: '',
  tournamentName: '',
  squadDateTime: '',
  timeZoneDisplayName: '',
  readOnly: false,
  isCancelled: false,
  allowChangeBetweenFreeEvents: false
};

export default EntryDetailSummary;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailSummary.jsx